import * as Models from '../types/models';

type BlockOfKind<T extends Models.BlockKind> = {
  [key in T]: Models.Block & { blockable: Models.Blockable<key> };
}[T];

export const isBlockOfKind = <T extends Models.BlockKind>(block: Models.Block, kind: T): block is BlockOfKind<T> =>
  block.kind === kind;
